import { Component, OnInit } from '@angular/core';

import { AppPropertiesService } from '../services/app-properties/app-properties.service';

/**
 * Component for displaying the header content.
 *
 * @author Jesse Bloomster e020902
 */
@Component({
	selector: 'claim-tracker-header',
	standalone: true,
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
	aoLogoSrc: string;

	/**
	 * @param appPropertiesService the global app properties service
	 */
	constructor(private appPropertiesService: AppPropertiesService) {}

	/**
	 * Called when the component is initialized.
	 */
	ngOnInit() {
		this.aoLogoSrc = this.appPropertiesService.appProperties.aoLogoUrl ?? '';
	}
}
